import cn from 'classnames'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { get } from '../helpers/Api'
import { formatWAX, sleep } from '../helpers/FormatLinks'
import CheckIndicator from '../checkindicator/CheckIndicator'
import MainButton from '../common/util/input/MainButton'
import { Context, useSharedState } from '../waxplorer/Waxplorer'
import {
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material'
import Link from '../common/util/input/Link'
import { getBoostAction } from '../helpers/WaxApi'
import { ModalActions } from '../assetpreview/ModalActions'
import { useToast } from '../ui/use-toast'
import { showErrorToast, showSuccessToast } from '../../utils/toasts'
import Link2 from '../common/util/input/Link2'

const BuyOfferBox = ({ asset }) => {
    const { t } = useTranslation('common')
    const [state, , { login }] = useSharedState()
    const [action, setAction] = useState(null)
    const [selectedOffer, setSelectedOffer] = useState(asset)

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const { blacklisted, template, collection, schema } = asset

    const { templateId } = template

    const buyContainerClassName = cn(
        'relative font-bold text-white block w-auto my-auto text-left',
    )

    const buttonClassName = cn(
        'w-32 h-12 md:h-8 xl:h-7 min-w-32 md:w-24 md:min-w-24 lg:w-20 lg:min-w-20 xl:w-20 xl:min-w-20 2xl:w-24 2xl:min-w-24 text-base md:text-sm m-auto',
    )

    const [isLoading, setIsLoading] = useState(false)
    const [created, setCreated] = useState(false)
    const [error, setError] = useState(false)
    const [, dispatch] = useContext(Context)

    const [canceledOffers, setCanceledOffers] = useState([])
    const [boughtOffers, setBoughtOffers] = useState([])
    const [loadingOffers, setLoadingOffers] = useState([])
    const [count, setCount] = useState(0)

    const [buyOffers, setBuyOffers] = useState(null)

    let offerable = false

    if (userName && templateId) {
        offerable = true
    }

    const parseBuyOffers = (res) => {
        setCreated(false)
        setBuyOffers(res)
    }

    useEffect(() => {
        if (templateId) {
            get(
                `buyoffers?term=${templateId}&collection=${collection.collectionName}&schema=${schema}&verified=all`,
                'wax-api',
            ).then(parseBuyOffers)
        }
    }, [templateId, created])

    function removeLoadingOffer(buyofferId) {
        const newLoaders = []
        for (const loadingOffer of loadingOffers) {
            if (loadingOffer !== buyofferId) {
                newLoaders.push(loadingOffer)
            }
        }
        setLoadingOffers(newLoaders)
    }

    const handleCallBack = async (info, action) => {
        if (info) {
            if (info['success']) {
                if (action === 'accept_buyoffer') {
                    boughtOffers.push(info['buyofferId'])
                    setBoughtOffers(boughtOffers)

                    removeLoadingOffer(info['buyofferId'])
                } else if (action === 'cancel') {
                    canceledOffers.push(info['buyofferId'])
                    setCanceledOffers(canceledOffers)

                    removeLoadingOffer(info['buyofferId'])
                } else if (action === 'create_buyoffer') {
                    await sleep(3000)

                    setCreated(true)

                    setCount(count + 1)
                }
            }
        }

        setIsLoading(false)
    }

    useEffect(() => {}, [count])

    const cancel = async (buyofferId) => {
        loadingOffers.push(buyofferId)
        setLoadingOffers(loadingOffers)
        setCount(count + 1)
        try {
            const result = await activeUser.session.transact(
                {
                    actions: [
                        getBoostAction(activeUser),
                        {
                            account: 'atomicmarket',
                            name: 'canceltbuyo',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                buyoffer_id: buyofferId,
                            },
                        },
                    ],
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            if (result?.response?.transaction_id) {
                callBack(
                    {
                        success: true,
                        buyofferId: buyofferId,
                        transactionId: result?.response?.transaction_id,
                    },
                    'cancel',
                )
            } else {
                callBack({ success: false, buyofferId: buyofferId }, 'cancel')
            }
        } catch (e) {
            callBack({ success: false, error: e.message }, 'cancel')
        }
    }

    const createbuyo = () => {
        setIsLoading(true)
        setSelectedOffer(asset)
        setAction('create_buyoffer')
    }

    const offerField = (
        <div className={buyContainerClassName}>
            <MainButton
                padding={'px-0'}
                fullWidth={true}
                onClick={createbuyo}
                className={'max-w-72'}
            >
                {t('buyoffers.create_template_offer')}
            </MainButton>
        </div>
    )

    const selloffer = async (offer) => {
        loadingOffers.push(offer.buyofferId)
        setLoadingOffers(loadingOffers)
        setAction('accept_buyoffer')
        setSelectedOffer(offer)
    }

    const { toast } = useToast()

    const callBack = (info, localAction = null) => {
        if (info?.success) {
            if (info?.transactionId) {
                showSuccessToast(
                    toast,
                    <Link2
                        external={true}
                        href={
                            'https://waxblock.io/transaction/' +
                            info.transactionId
                        }
                    >
                        <div className={'text-xs font-medium'}>
                            {info.transactionId.substr(0, 32) + '...'}
                        </div>
                    </Link2>,
                )
            }
        } else {
            if (info?.buyofferId) {
                removeLoadingOffer(info.buyofferId)
            } else {
                const newLoaders = []
                setLoadingOffers(newLoaders)
            }
        }
        if (info?.error) {
            showErrorToast(toast, info.error)
        }

        handleCallBack(info, localAction ? localAction : action)

        setAction(null)
    }

    return (
        <div className={cn('w-full mx-0 py-2 h-auto')}>
            <ModalActions
                action={action}
                asset={selectedOffer}
                callBack={callBack}
            />
            <div className="text-left font-light dark:!text-white text-black  p-2 text-2xl lg:text-4xl">
                {t('navigation.buy_offers')}
            </div>
            <div>
                {buyOffers && buyOffers.length > 0 ? (
                    <Table size="medium" className="">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <b>{t('search.buyer')}</b>
                                </TableCell>
                                <TableCell>
                                    <b>{t('search.price')}</b>
                                </TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyOffers.map((offer) => (
                                <TableRow>
                                    <TableCell>
                                        <Link href={'/user/' + offer.buyer}>
                                            {offer.buyer}
                                        </Link>
                                    </TableCell>
                                    <TableCell>
                                        {formatWAX(offer.price)}
                                    </TableCell>
                                    <TableCell>
                                        {loadingOffers.includes(
                                            offer.buyofferId,
                                        ) ? (
                                            <LinearProgress />
                                        ) : !userName ? (
                                            <div className={buttonClassName}>
                                                <MainButton
                                                    fullWidth={true}
                                                    className={buttonClassName}
                                                    onClick={() => login()}
                                                >
                                                    {t('navigation.login')}
                                                </MainButton>
                                            </div>
                                        ) : offer.buyer === userName ? (
                                            canceledOffers.includes(
                                                offer.buyofferId,
                                            ) ? (
                                                <div
                                                    className={buttonClassName}
                                                >
                                                    <CheckIndicator />
                                                </div>
                                            ) : (
                                                <div
                                                    className={buttonClassName}
                                                >
                                                    <MainButton
                                                        className={
                                                            buttonClassName
                                                        }
                                                        onClick={() =>
                                                            cancel(
                                                                offer.buyofferId,
                                                            )
                                                        }
                                                    >
                                                        {t('asset.cancel')}
                                                    </MainButton>
                                                </div>
                                            )
                                        ) : boughtOffers.includes(
                                              offer.buyofferId,
                                          ) ? (
                                            <CheckIndicator />
                                        ) : (
                                            <div className={buttonClassName}>
                                                <MainButton
                                                    fullWidth={true}
                                                    className={buttonClassName}
                                                    onClick={() =>
                                                        selloffer(offer)
                                                    }
                                                >
                                                    {t('trade.accept')}
                                                </MainButton>
                                            </div>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <div className={'w-full p-2 mt-4'}>
                        {t('buyoffers.no_active_buy_offers')}
                    </div>
                )}
            </div>
            <div className={'w-full flex m-auto justify-center p-2'}>
                {!isLoading && !blacklisted && offerable ? offerField : ''}
            </div>
        </div>
    )
}

export default BuyOfferBox
